import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Autocomplete, Skeleton } from "@material-ui/lab";
import { Button, TextField } from "@material-ui/core";
import swal from "sweetalert";
import { toast } from "react-hot-toast";
import {
  CheckRounded,
  CloseRounded,
  ApartmentRounded,
} from "@material-ui/icons";
import { fetchSuperInstitutos } from "../../../../shared/fetchers/classics/institutos/verSuperInstitutos";
import { eliminarSuperInstituto } from "../../../../shared/fetchers/classics/institutos/eliminarSuperInstituto";

const EliminarSuperInstituto = () => {
  const queryClient = useQueryClient();
  const [superInstituto, setSuperInstituto] = useState(null);

  const {
    data: superInstitutos,
    isLoading,
    isError,
  } = useQuery(["superInstitutos"], fetchSuperInstitutos);

  const SubmitForm = async (e) => {
    e.preventDefault();

    const check = await swal({
      title: "¿Estás seguro?",
      text: `Una vez eliminado, no podrás recuperar el super instituto "${superInstituto.nombre}"!`,
      icon: "warning",
      buttons: ["Cancelar", "Eliminar"],
      dangerMode: true,
    });

    if (!superInstituto || !check) return toast.success("Operación cancelada");

    const { info, status } = await eliminarSuperInstituto({
      nombre: superInstituto.nombre,
      id: superInstituto.idSuperInstituto,
    });

    if (!status)
      return swal({
        title: "Error",
        text: info ?? "Ha ocurrido un error eliminando el super instituto",
        icon: "error",
      });

    queryClient.invalidateQueries({
      queryKey: ["superInstitutos"],
    });

    toast.success("Super instituto eliminado correctamente");

    setSuperInstituto(null);
  };

  if (isLoading)
    return (
      <>
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </>
    );

  if (isError) return <div>Ha ocurrido un error</div>;

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <ApartmentRounded />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Eliminar un super instituto</div>
      </div>
      <Container fluid>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <form>
              <label className="admin-label-text mt-3 d-block">
                Selecciona un super instituto:
              </label>
              <Autocomplete
                options={superInstitutos || []}
                getOptionLabel={(option) => option.nombre}
                value={superInstituto}
                onChange={(_, value) => setSuperInstituto(value)}
                noOptionsText="Sin resultados"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    style={{
                      width: "100%",
                      fontFamily: "'Noto Sans JP', sans-serif",
                    }}
                  />
                )}
              />
              <div className="d-flex justify-content-end mt-4">
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!superInstituto}
                  type="submit"
                  onClick={(e) => SubmitForm(e)}
                  startIcon={<CheckRounded />}
                  style={{ background: "#f05050" }}
                >
                  Eliminar
                </Button>
                <Button
                  variant="contained"
                  disabled={!superInstituto}
                  color="primary"
                  onClick={() => {
                    setSuperInstituto(null);
                  }}
                  className="ml-2"
                  startIcon={<CloseRounded style={{ fontSize: "25px" }} />}
                  style={{ background: "#81c868" }}
                >
                  Cancelar
                </Button>
              </div>
            </form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EliminarSuperInstituto; 